import { DefaultError } from 'errors/DefaultError';

export class AwsWafError extends DefaultError {
  constructor({ error }) {
    super({
      error,
      name: AwsWafError.name,
      message: `Unfortunately, we're having technical problems at the moment.
                Please try again later. Thank you for your patience, We're
                sorry for the inconvenience this might cause.`
    });
  }
  static get name() {
    return 'AwsWafError';
  }
}
